

export const Bio = {
  name: "Mostafa Rayhan",
  roles: [
    "Software Engineer",
    "Full Stack Developer",
    "Software Developer",
    "Designer",
    "Freelancer",
  ],
  description:
    "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
  github: "https://github.com/Mostafa-Rayhan",
  resume:
    "https://drive.google.com/file/d/1LW9V8uXRpiDTqZOfFBDbPSn-e25FIj1I/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/mostafa-rayhan-2972391a9/",
  twitter: "https://twitter.com/mostafarayhan57",
  insta: "https://www.instagram.com/mostafarayhan7404/",
  facebook: "https://www.facebook.com/profile.php?id=100008482801410",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Redux",
        image:
          "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      },
      {
        name: "Next Js",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=",
      },
      {
        name: "Angular",
        image:
          "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjwhRE9DVFlQRSBzdmcgIFBVQkxJQyAnLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4nICAnaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkJz48c3ZnIGhlaWdodD0iNTEycHgiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTI7IiB2ZXJzaW9uPSIxLjEiIHZpZXdCb3g9IjAgMCA1MTIgNTEyIiB3aWR0aD0iNTEycHgiIHhtbDpzcGFjZT0icHJlc2VydmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPjxnIGlkPSJfeDMyXzEtYW5ndWxhciI+PGc+PHBhdGggZD0iTTIxNi44NzksMjY4LjQyNmg3OC4yNDFMMjU2LDE3NC4zNzJMMjE2Ljg3OSwyNjguNDI2TDIxNi44NzksMjY4LjQyNnogTTI1NiwyNi4wMDFMNDIuNjM1LDEwMi4zOTUgICAgbDMyLjY1MiwyODMuMDgxTDI1Niw0ODUuOTk5bDE4MC43MTItMTAwLjUyM2wzMi42NTMtMjgzLjA4MUwyNTYsMjYuMDAxeiBNMzg5LjY4OCwzNzYuOTU3aC00OS45MDRsLTI2LjktNjcuMTUzSDE5OS4zMjEgICAgbC0yNi45MDMsNjcuMTUzaC01MC4wMDNMMjU2LDc2LjgyN0wzODkuNjg4LDM3Ni45NTd6IiBzdHlsZT0iZmlsbDojREQwMDMxOyIvPjwvZz48L2c+PGcgaWQ9IkxheWVyXzEiLz48L3N2Zz4=",
      },
      {
        name: "Vue",
        image: "https://www.svgrepo.com/show/452130/vue.svg",
      },
      {
        name: "Vuetify",
        image: "https://www.svgrepo.com/show/306946/vuetify.svg",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "Jquery",
        image:
          "https://www.svgrepo.com/show/508923/jquery.svg",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "TypeScript",
        image:
          "https://cdn.worldvectorlogo.com/logos/typescript.svg",
      },
      {
        name: "Bootstrap",
        image:
        "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "Tailwind CSS",
        image:
          "https://cdn.worldvectorlogo.com/logos/tailwind-css-2.svg",
      },
      {
        name: "Material UI",
        image:
          "https://www.svgrepo.com/show/354048/material-ui.svg",
      },
      {
        name: "Blazor",
        image:
          "https://www.svgrepo.com/show/330066/blazor.svg",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "ASP.NET",
        image:
          "https://www.svgrepo.com/show/508894/aspnet.svg",
      },
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "Django",
        image:
          "https://cdn.worldvectorlogo.com/logos/django.svg",
      },
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express Js",
        image:
          "https://www.svgrepo.com/show/330398/express.svg",
      },
      {
        name: "PHP",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/php/php-original.svg",
      },
      // {
      //   name: "Graph Ql",
      //   image: "https://www.vectorlogo.zone/logos/graphql/graphql-icon.svg",
      // },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "Oracle",
        image:
          "https://www.svgrepo.com/show/448245/oracle.svg",
      },
      {
        name: "SQLite3",
        image:
          "https://www.svgrepo.com/show/374094/sqlite.svg",
      },
      // {
      //   name: "Postgresql",
      //   image: "https://www.postgresql.org/media/img/about/press/elephant.png",
      // },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      },
    ],
  },
  {
    title: "Good Knowledge",
    skills: [
      {
        name: "Dart",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/91/Dart-logo-icon.svg/2048px-Dart-logo-icon.svg.png",
      },
      {
        name: "Flutter",
        image:
          "https://cdn-images-1.medium.com/max/1200/1*5-aoK8IBmXve5whBQM90GA.png",
      },
      {
        name: "Android Studio",
        image:
          "https://developer.android.com/static/studio/images/new-studio-logo-1_1920.png",
      },
      {
        name: "C",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/c/c-original.svg",
      },
      {
        name: "C++",
        image:
          "https://www.svgrepo.com/show/452184/csharp.svg",
      },
      {
        name: "C#",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/cplusplus/cplusplus-original.svg",
      },
      {
        name: "Machine Learning",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTwNufTd72akt3Ffc6-RYGyEkZrV3IF7IJGwQ&usqp=CAU",
      },
      {
        name: "Web Scrapping",
        image:
          "data:image/jpeg;base64,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",
      },

    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://www.svgrepo.com/show/452210/git.svg",
      },
      {
        name: "GitHub",
        image:
          "https://www.svgrepo.com/show/475654/github-color.svg",
      },
      {
        name: "Azure",
        image:
          "https://www.svgrepo.com/show/448274/azure.svg",
      },
      {
        name: "Docker",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
      },
      {
        name: "AWS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/93/Amazon_Web_Services_Logo.svg/2560px-Amazon_Web_Services_Logo.svg.png",
      },
      {
        name: "Linux",
        image:
          "https://www.svgrepo.com/show/448236/linux.svg",
      },
      {
        name: "Netlify",
        image:
          "https://www.svgrepo.com/show/376339/netlify.svg",
      },
      {
        name: "Vercel",
        image:
          "https://www.svgrepo.com/show/378475/vercel-fill.svg",
      },
      {
        name: "Visual Studio",
        image:
          "https://www.svgrepo.com/show/354520/visual-studio.svg",
      },
      {
        name: "VS Code",
        image:
          "https://www.svgrepo.com/show/354522/visual-studio-code.svg",
      },
      {
        name: "Postman",
        image:
          "https://www.svgrepo.com/show/354202/postman-icon.svg",
      },
      // {
      //   name: "Adobe XD",
      //   image:
      //     "https://camo.githubusercontent.com/c205ecbe12500177d102169d97bc1c17c545155fdf5ec78c08d54ac53e5b38c1/68747470733a2f2f63646e2e776f726c64766563746f726c6f676f2e636f6d2f6c6f676f732f61646f62652d78642e737667",
      // },
      {
        name: "Figma",
        image:
          "https://www.svgrepo.com/show/354987/figma.svg",
      },
      {
        name: "Canva",
        image:
          "https://freelogopng.com/images/all_img/1656733807canva-icon-png.png",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "http://fintechhub.com.bd/wp-content/uploads/2024/07/Fintech-Hub-logo.png",
    role: "Junior Software Engineering",
    company: "FiNTECH HUB Ltd ( Development Engineering )",
    date: "July 2024 - Present",
    desc: " Working on a General Banking Solution, Core Banking Solution, Security Module, and Administration Module using ASP.NET 8, BLAZOR, and Oracle DB (Store Procedure).",
    skills: [
      "Blazor",
      "ASP.NET 8",
      "ASP.NET Core",
      "Oracle",
      "PL/SQL",
      "IIS",
      "Microsoft Azure",
      "Scrum",
    ],
    doc: "",
  },
  {
    id: 1,
    img: "https://leads.com.bd/wp-content/uploads/2022/02/LEADS-1-150x29.png",
    role: "Junior Software Engineering",
    company: "LEADS Corporation Limited ( Banking Solutions )",
    date: "April 2024 - June 2024",
    desc: "The experienced developer is proficient in ASP.NET Core 6, Vue.js, and Oracle DB (Store Procedure) and has a track record of delivering robust banking software.",
    skills: [
      "Vue3",
      "Vuetify",
      "ASP.NET 6",
      "ASP.NET Web API",
      "Oracle",
      "PL/SQL",
      "TypeScript",
      "IIS",
      "Microsoft Azure",
      "Scrum",
    ],
    doc: "",
  },
  {
    id: 2,
    img: "https://pharmaid-rx.com/wp-content/themes/pharma/image/Logo%20-%20Customer%20Primary.png",
    role: "Software Developer",
    company: "PharmAid-Rx",
    date: "March 2023 - December 2023",
    desc: "Working on Software Maintenance and Development using the latest technologies",
    skills: [
      "React Js",
      "Next Js",
      "Angular Js",
      "TypeScript",
      "Node Js",
      "MongoDB",
      "Python",
      "Django",
    ],
    doc: "",
  },
  {
    id: 3,
    img: "https://static.wixstatic.com/media/38659e_a93afd48133a406aa537056fac52a4b1~mv2.png/v1/crop/x_171,y_171,w_657,h_657/fill/w_89,h_89,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/SHADER.png",
    role: "Full Stack Developer",
    company: "Shader Bytes",
    date: "October 2022 - March 2023",
    desc: "Design and Development user-friendly website using latest technologies and learn fast",
    skills: [
      "React JS",
      "Next Js",
      "Node Js",
      "MongoDB",
      "Django",
      "SQLite3",
      "PHP",
      "MySQL",
    ],
    doc: "",
  },
  // {
  //   id: 4,
  //   img: "https://media.licdn.com/dms/image/C4E0BAQFMvRcuRrESgg/company-logo_200_200/0/1635401024489/itqan_analytics_software_limited_logo?e=1711584000&v=beta&t=QPetMJxYV1k7_qIbDMDSSifjwzDaley0v1u8rOuR0Aw",
  //   role: "Jr. Software Developer",
  //   company: "ITQAN Analytics & Software Limited",
  //   date: "January 2022 - October 2022",
  //   desc: "Developed user-friendly website using Django Framework, API Creating and Web Scraping",
  //   skills: [
  //     "Python",
  //     "Django",
  //     "Django REST Framework",
  //     "MySQL",
  //     "SQLite3",
  //     "Web Scrapping",
  //   ],
  //   doc: "",
  // },
  
];

export const education = [
  {
    id: 0,
    img: "https://seeklogo.com/images/D/daffodil-international-university-logo-11C0D0D39A-seeklogo.com.png",
    school: "Daffodil International University, Ashulia, Dhaka",
    date: "Apr 2019 - Jun 2023",
    grade: "3.56 CGPA",
    desc: "I have successfully completed my Bachelor's in Computer Science and Engineering at Daffodil International University. I have completed 12 semesters and have a CGPA of 3.55. I have taken courses in Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, Software Engineering and Computer Networks, among others. I am also a member of the DIU CPC - Daffodil International University Computer and Programming Club at DIU, where I am learning and working on exciting projects with a team of talented developers.",
    degree: "Bachelor of Science - B.Sc., Computer Science and Engineering",
  },
  {
    id: 1,
    img: "https://media.licdn.com/dms/image/C510BAQEzwi8-ZfCBGQ/company-logo_200_200/0/1630631149347?e=2147483647&v=beta&t=g_-lSYjxHJlsB8WffpXajdz-7NlURHgPh0S4dg2FBcE",
    school: "Shahid Syed Nazrul Islam College, Mymensingh",
    date: "2016 - 2018",
    grade: "4.75 GPA",
    desc: "I completed my class 12 high school education at Shahid Syed Nazrul Islam College, Mymensingh, where I studied Science Group.",
    degree: "Higher Secondary School Certificate - H.S.C.",
  },
  {
    id: 2,
    img: "https://i.ibb.co/ctSXPYR/download.jpg",
    school: "Ashujia J N C Institution, Ashujia, Kendua, Netrokona",
    date: "2011 - 2016",
    grade: "5.00 GPA",
    desc: "I completed my class 10 education at Ashujia J N C Institution, Ashujia, Kendua, Netrokona, where I studied Science Group.",
    degree: "Secondary School Certificate - S.S.C.",
  },
];

export const projects = [
  {
    id: 0,
    title: "UpTurn Idea",
    date: "Jan 2024 - Apr 2024",
    description:
      "Upturn idea is a 'Digital marketing' agency.Upturn Idea will assist you in reaching your financial and branding goals.",
    image:
      "https://i.ibb.co.com/kgytCk57/Screenshot-2025-03-02-011311.jpg",
    tags: [
      "HTML",
      "CSS",
      "Bootstrap",
      "React",
      "Next.js",
      "Node.js",
      "MongoDB",
    ],
    category: "full stack",
    github: "",
    webapp: "https://upturnidea.com/",
  },
  {
    id: 1,
    title: "Payhold Dashboard",
    date: "Jan 2023 - Feb 2023",
    description:
      "A complete online application called Payhold gives consumers a safe and effective platform for conducting domestic and international transactions while also enabling smooth communication via a chat function. The website allows users to add their bank accounts, deposit and withdraw money, and conduct secure transactions using SSLCommerze and credit card services.",
    image:
      "https://dl.dropboxusercontent.com/scl/fi/4ykvf55rbvly6ahwzfcb2/img1.jpg?rlkey=s4hdxai48eizh3m826zitzxsc&dl=0",
    tags: [
      "HTML",
      "CSS",
      "Bootstrap",
      "Javascript",
      "jQuery",
    ],
    category: "front end",
    github: "https://github.com/Mostafa-Rayhan/Payhold-Deshboard",
    webapp: "https://payhold.netlify.app/",
  },
  {
    id: 2,
    title: "Basic Education",
    date: "Nov 2022 - Jan 2023",
    description:
      "Basic Education is an online learning platform that provides high-quality educational courses to students all around the world. Our online courses cover a wide range of topics, from academic subjects like math and science to professional development courses in fields like business and technology.",
    image:
      "https://i.ibb.co/9v5Wz8M/Basic-Education.jpg",
    tags: [
      "React",
      "Next.Js",
      "Bootstrap",
      "MDBootstrap",
    ],
    category: "front end",
    github: "",
    webapp: "https://basiceducation.netlify.app/",
    member: [
          {
            name: "Mostafa Rayhan",
            img: "https://avatars.githubusercontent.com/u/64858659?v=4",
            linkedin: "https://www.linkedin.com/in/mostafa-rayhan-2972391a9/",
            github: "https://github.com/Mostafa-Rayhan",
          },
          {
            name: "Akramul Ratul",
            img: "https://avatars.githubusercontent.com/u/68425589?v=4",
            linkedin: "https://www.linkedin.com/in/akramul-ratul/",
            github: "https://github.com/akramulratul",
          },
        ],
  },
  {
    id: 3,
    title: "Best Video Network",
    date: "March 2023 - April 2023",
    description:
      "Our digital signage gallery showcases our signage projects with pictures of digital signage",
    image:
      "https://i.ibb.co/FYcgHjY/Best-Video-Network.jpg",
    tags: [
      "React",
      "Next.Js",
      "Tailwind CSS",
    ],
    category: "front end",
    github: "",
    webapp: "https://next-js-two-brown.vercel.app/",
  },
  {
    id: 1,
    title: "Mirchi Movies",
    date: "February 2023 - March 2023",
    description:
      "Mirichi Movies is a dynamic movie website crafted with HTML, CSS, SCSS, Bootstrap, jQuery, and Django, offering users a seamless browsing experience. With its sleek design and intuitive interface, users can effortlessly explore a vast collection of films, making it a standout addition to any portfolio for its innovative use of web technologies in the realm of entertainment.",
    image:
      "https://i.ibb.co/jvSpGZQ/Mirchi-Movies.jpg",
    tags: [
      "HTML",
      "CSS",
      "SCSS",
      "Bootstrap",
      "Javascript",
      "jQuery",
      "Django",
    ],
    category: "back end",
    github: "https://github.com/Mostafa-Rayhan/Mirchi-Movie-Django.git",
    webapp: "https://mirichimovies.netlify.app/",
  },
  {
    id: 1,
    title: "BulkPulses",
    date: "December 2023 - January 2024",
    description:
      "BulkPulse is a wholesale marketplace where you can buy pulses in large quantities and also at a reasonable price. We provide delivery of our pulses in 64 districts of Bangladesh. You will get the best quality and clean pulses from us. To get these best quality pulses, you can order them on our website also you can contact us through our contact number.",
    image:
      "https://i.ibb.co/ZJPBfSf/Screenshot-2024-02-08-020548.jpg",
    tags: [
      "React",
      "Node.Js",
      "Express.Js",
      "Tailwind CSS",
      "Material UI",
      "MongoDB",
    ],
    category: "full stack",
    github: "https://github.com/Mostafa-Rayhan/BulkPulses-MERN.git",
    webapp: "https://bulkpulse.netlify.app/",
  },
  // {
  //   id: 0,
  //   title: "Podstream",
  //   date: "Apr 2023 - May 2023",
  //   description:
  //     "Developed a full-stack web application that allows users to search for, play, and pause their favorite podcasts on demand and create podcasts. Implemented user authentication using Google Auth and Jwt Auth, made responsive user interface with React JS that provides users with a seamless experience across all devices. Practiced agile methodologies to optimize team efficiency and communication.",
  //   image:
  //     "https://user-images.githubusercontent.com/64485885/234602896-a1bd8bcc-b72b-4821-83d6-8ad885bf435e.png",
  //   tags: ["React Js", "MongoDb", "Node Js", "Express Js", "Redux"],
  //   category: "front end",
  //   github: "https://github.com/rishavchanda/Podstream",
  //   webapp: "https://podstream.netlify.app/",
  //   member: [
  //     {
  //       name: "Rishav Chanda",
  //       img: "https://avatars.githubusercontent.com/u/64485885?v=4",
  //       linkedin: "https://www.linkedin.com/in/rishav-chanda-b89a791b3/",
  //       github: "https://github.com/rishavchanda/",
  //     },
  //     {
  //       name: "Upasana Chaudhuri",
  //       img: "https://avatars.githubusercontent.com/u/100614635?v=4",
  //       linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
  //       github: "https://github.com/upasana0710",
  //     },
  //   ],
  // },
  // {
  //   id: 1,
  //   title: "Vexa",
  //   date: "Oct 2022 - Present",
  //   description:
  //     "Designed and developed the Vexa project, a project management app that helps users and teams stay organized and on track. Implemented key features such as task tracking, team collaboration, and time tracking to improve productivity and project outcomes and also invite team/project members. The plan is to add a community of users where they can find developers and other team members and chat system implementation.",
  //   image:
  //     "https://user-images.githubusercontent.com/64485885/234916413-96296f13-fe4b-4cc4-b215-e72bd7c27928.png",
  //   tags: [
  //     "React Js",
  //     "MongoDb",
  //     "Node Js",
  //     "Express Js",
  //     "Redux",
  //     "NodeMailer",
  //   ],
  //   category: "front end",
  //   github: "https://github.com/rishavchanda/Project-Management-App",
  //   webapp: "https://vexa-app.netlify.app/",
  // },
  // {
  //   id: 2,
  //   title: "Brain Tumor Detection",
  //   date: "Jan 2023 - Mar 2023",
  //   description:
  //     "Preprocessed and augmented the dataset to improve model accuracy, trained the model, created API using model and Python, and used React web app for the project's front end. Achievements: Achieved an accuracy of 99.2% to accurately detect brain tumors from medical images.",
  //   image:
  //     "https://github.com/rishavchanda/Brain-Tumor-Detection/raw/main/Readme_resource/Image2.png",
  //   tags: ["Python", "Keras", "TensorFlow", "VGG16", "Pickle", "React"],
  //   category: "machine learning",
  //   github: "https://github.com/rishavchanda/Brain-Tumor-Detection",
  //   webapp: "https://brain-tumor.netlify.app/",
  //   member: [
  //     {
  //       name: "Rishav Chanda",
  //       img: "https://avatars.githubusercontent.com/u/64485885?v=4",
  //       linkedin: "https://www.linkedin.com/in/rishav-chanda-b89a791b3/",
  //       github: "https://github.com/rishavchanda/",
  //     },
  //     {
  //       name: "Upasana Chaudhuri",
  //       img: "https://avatars.githubusercontent.com/u/100614635?v=4",
  //       linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
  //       github: "https://github.com/upasana0710",
  //     },
  //   ],
  // },
  // {
  //   id: 3,
  //   title: "Buckoid",
  //   date: "Dec 2021 - Apr 2022",
  //   description:
  //     "App Is Currently In Playstore 100+ Downloads. This Project proposes an “Expense Tracking App”. Keep track of your personal expenses and compare them to your monthly income with the budget planner. It has Google Drive Cloud API for Backup of User Room Database. Made with Kotlin in MVVM Architecture & Live Data.",
  //   image:
  //     "https://camo.githubusercontent.com/fbf405040ae86b5d4a40f24e4ac034982cb8c0e2d850560ba64527997b258be8/68747470733a2f2f666972656261736573746f726167652e676f6f676c65617069732e636f6d2f76302f622f6c6f67696e2d65613565322e61707073706f742e636f6d2f6f2f4255434b4f49442532302831292e706e673f616c743d6d6564696126746f6b656e3d32653735376235372d323964372d346263612d613562322d653164346538313432373435",
  //   tags: ["Kotlin", "MVVM", "Room Database", "Google Drive Cloud API"],
  //   category: "android app",
  //   github: "https://github.com/rishavchanda/Buckoid-Android-App",
  //   webapp: "https://play.google.com/store/apps/details?id=com.rishav.buckoid",
  // },
  // {
  //   id: 10,
  //   title: "Job Finding App",
  //   date: "Jun 2023 - Jul 2023",
  //   description:
  //     "A Job Finding App made with React Native, Axios. Users can search for any job coming from API and apply there.",
  //   image:
  //     "https://user-images.githubusercontent.com/64485885/255237090-cf798a2c-1b41-4bb7-b904-b5353a1f08e8.png",
  //   tags: ["React Native", "JavaScript", "Axios"],
  //   category: "android app",
  //   github: "https://github.com/rishavchanda/Job-finder-App",
  //   webapp: "https://github.com/rishavchanda/Job-finder-App",
  // },
  // {
  //   id: 4,
  //   title: "Whatsapp Clone",
  //   date: "Jul 2021",
  //   description:
  //     "A WhatsApp clone made with React JS, Firebase, and Material UI. It has Phone Authentication, Real-time Database. It has a chat room where users can chat with each other. It has a sidebar where users can see all the chat rooms and can create a new chat room. It has a login page where users can log in with their Google account.",
  //   image:
  //     "https://firebasestorage.googleapis.com/v0/b/whatsapp-clone-rishav.appspot.com/o/Screenshot%20(151).png?alt=media&token=48391593-1ef0-4a8c-a92a-eb82bdf38e89",
  //   tags: ["React Js", "Firebase", "Firestore", "Node JS"],
  //   category: "front end",
  //   github: "https://github.com/rishavchanda/Whatsapp-Clone-React-Js",
  //   webapp: "https://whatsapp-clone-rishav.web.app",
  // },
  // {
  //   id: 5,
  //   title: "Todo Web App",
  //   date: "Jun 2021",
  //   description:
  //     " A Todo Web App made with React JS, Redux, and Material UI. It has a login page where users can log in with their Google account. It has a sidebar where users can see all the tasks and can create a new task. It has a calendar where users can see all the tasks on a particular date. It has a search bar where users can search for a particular task.",
  //   image:
  //     "https://camo.githubusercontent.com/a328255ad96f861f57d25096d28018ab2656c689a1456b0d145764009bed2d1a/68747470733a2f2f666972656261736573746f726167652e676f6f676c65617069732e636f6d2f76302f622f746f646f2d6170702d63386331392e61707073706f742e636f6d2f6f2f53637265656e73686f74253230283938292e706e673f616c743d6d6564696126746f6b656e3d33643335646366322d626666322d343730382d393031632d343232383866383332386633",
  //   tags: ["React Js", "Local Storage", "AWS Auth", "Node JS"],
  //   category: "front end",
  //   github: "https://github.com/rishavchanda/Todo-Web-App",
  //   webapp: "https://rishav-react-todo.netlify.app/",
  // },
  // {
  //   id: 6,
  //   title: "Breaking Bad",
  //   date: "Jun 2021",
  //   description:
  //     "A simple react app that shows the characters of the famous TV series Breaking Bad. It uses the Breaking Bad API to fetch the data. It also has a search bar to search for a particular character.",
  //   image:
  //     "https://camo.githubusercontent.com/cd07010cbeb90cb1b43a5d6162784326aef02210ef7d41a0f9ae043b3e392378/68747470733a2f2f666972656261736573746f726167652e676f6f676c65617069732e636f6d2f76302f622f746f646f2d6170702d63386331392e61707073706f742e636f6d2f6f2f53637265656e73686f7425323028313534292e706e673f616c743d6d6564696126746f6b656e3d65613439383630632d303435362d343333342d616435372d336239346663303333363263",
  //   tags: ["React Js", "API", "Axios", "Node JS"],
  //   category: "web app",
  //   github: "https://github.com/rishavchanda/Breaking-Bad",
  //   webapp: "https://breaking-bad-webapp.netlify.app",
  // },
  // {
  //   id: 7,
  //   title: "Quiz App",
  //   date: "Dec 2020 - Jan 2021",
  //   description:
  //     "A android quiz app made with Java and Firebase. It has a login page where users can log in with their Google account. It has a sidebar where users can see all the quiz categories and can create a new quiz. It has a leaderboard where users can see the top 10 scorers. It has a search bar where users can search for a particular quiz.",
  //   image:
  //     "https://github-production-user-asset-6210df.s3.amazonaws.com/64485885/239726262-c1b061d1-d9d0-42ef-9f1c-0412d14bc4f6.gif",
  //   tags: ["Java", "Android Studio", "Firebase", "Google Auth"],
  //   category: "android app",
  //   github: "https://github.com/rishavchanda/Quiz-Earn",
  //   webapp: "https://github.com/rishavchanda/Quiz-Earn",
  // },
  // {
  //   id: 8,
  //   title: "Face Recognition",
  //   date: "Jan 2021",
  //   description:
  //     "A Face recognition python app made with OpenCV. It uses face_recognition library to detect faces. It uses the webcam to detect faces. It also has a search bar to search for a particular face.",
  //   image:
  //     "https://camo.githubusercontent.com/a8b3e1ebf26d4c95f75bc6671189a3590eb67eb8332d7c7452492990e731efb9/68747470733a2f2f77617265686f7573652d63616d6f2e696e67726573732e636d68312e707366686f737465642e6f72672f356137383335396561323762643261633232336437656662306639303831306437373930383436312f363837343734373037333361326632663633366336663735363432653637363937343638373536323735373336353732363336663665373436353665373432653633366636643266363137333733363537343733326633383339333633363339333232663332333433343333333033333339333832663333333636363330363533333636333032643331333336333632326433313331363533373264333833323335333832643334363433303633333936333635333136353334333133393265363736393636",
  //   tags: ["Python", "Keras", "TensorFlow", "VGG16", "Pickle", "React"],
  //   category: "machine learning",
  //   github: "https://github.com/rishavchanda/Face-Recodnition-AI-with-Python",
  //   webapp: "https://github.com/rishavchanda/Face-Recodnition-AI-with-Python",
  // },
];

export const TimeLineData = [
  { year: 2017, text: "Started my journey" },
  { year: 2018, text: "Worked as a freelance developer" },
  { year: 2019, text: "Founded JavaScript Mastery" },
  { year: 2020, text: "Shared my projects with the world" },
  { year: 2021, text: "Started my own platform" },
];
